// Date-night stubs — slightly more involved than weeknight,
// presentation matters, romantic or impressive. Fires Fri/Sat
// evenings.

export const DATE_NIGHT_STUBS = [
  {
    id: "carbonara-classico",
    title: "Spaghetti Carbonara",
    emoji: "🥓",
    blurb: "Guanciale, eggs, pecorino — no cream, ever",
    discoveryTags: ["date-night", "weeknight", "comfort-food"],
    cuisine: "italian",
    course: "main",
    mealTiming: "dinner",
    difficulty: "medium",
    estimatedTime: 25,
    keyIngredients: ["spaghetti", "guanciale", "eggs", "pecorino", "black_pepper"],
    buildHint: "render guanciale slow for fat, OFF heat toss with egg + cheese + starchy pasta water until silky, NEVER scramble — pan must be cooler than 150F",
    producesCanonical: null,
  },
  {
    id: "mushroom-risotto",
    title: "Mushroom Risotto",
    emoji: "🍄",
    blurb: "Slow-stirred arborio with earthy mushrooms",
    discoveryTags: ["date-night", "comfort-food", "cold-weather"],
    cuisine: "italian",
    course: "main",
    mealTiming: "dinner",
    difficulty: "medium",
    estimatedTime: 45,
    keyIngredients: ["arborio_rice", "mushrooms", "shallot", "white_wine", "parmesan", "butter", "chicken_stock"],
    buildHint: "toast rice in butter + shallot, deglaze with wine, add hot stock 1 ladle at a time stirring constantly 18-20 min, mantecatura — beat in cold butter + parm off heat",
    producesCanonical: null,
  },
  {
    id: "seared-scallops",
    title: "Seared Scallops",
    emoji: "🦪",
    blurb: "Golden crust, butter-bathed, lemon finish",
    discoveryTags: ["date-night", "valentines", "newYearsEve"],
    cuisine: "french",
    course: "main",
    mealTiming: "dinner",
    difficulty: "medium",
    estimatedTime: 20,
    keyIngredients: ["scallops", "butter", "lemon", "garlic", "parsley"],
    buildHint: "pat scallops bone-dry — moisture kills the crust, ripping hot pan with neutral oil, 90 sec untouched per side, finish with butter + garlic + lemon",
    producesCanonical: null,
  },
  {
    id: "rack-of-lamb",
    title: "Rack of Lamb",
    emoji: "🥩",
    blurb: "Herb-crusted, pink center, rosemary jus",
    discoveryTags: ["date-night", "valentines", "easter", "christmas"],
    cuisine: "french",
    course: "main",
    mealTiming: "dinner",
    difficulty: "medium",
    estimatedTime: 60,
    keyIngredients: ["lamb_rack", "rosemary", "garlic", "dijon_mustard", "breadcrumbs"],
    buildHint: "sear fat-cap golden, brush with dijon + herb-breadcrumb crust, roast 400F to 125F internal for medium-rare, rest 10 min before slicing between bones",
    producesCanonical: null,
  },
];
